import { VIP_PROGRAMS_ENUM } from '@mg/web-components/types'

const showVipFeatures = (vipType: string | null | undefined) => {
  return (
    vipType === VIP_PROGRAMS_ENUM.VIP_PROGRAM ||
    vipType === VIP_PROGRAMS_ENUM.VIP_PLUS_PROGRAM
  )
}

export default showVipFeatures
